const headers = {
  Authorization: process.env.KEY_AUTHORIZATION_DIGISAC,
}

export const state = () => ({
  sendMensage: '',
})

export const getters = {}

export const mutations = {}

export const actions = {
  async actionSendMessage({ commit }, message) {
    await this.$axios.$post(
      `${process.env.API_DIGISAC}/messages`,
      {
        serviceId: process.env.SERVICE_ID_DIGISAC,
        dontOpenTicket: true,
        ...message,
      },
      {
        headers,
      }
    )
  },
}
